<div class="extend-bid-closing-dialog">
  <h2 mat-dialog-title>Extend Bid Closing Date</h2>
  <p class="dialog-description">Set a new closing date and time. All invitees will receive an email with the updated date.</p>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field class="field-date">
      <mat-label>New closing date</mat-label>
      <input matInput type="date" formControlName="closing_date" [min]="minDate">
      <mat-error>Required</mat-error>
    </mat-form-field>
    <mat-form-field  class="field-time">
      <mat-label>Time</mat-label>
      <input matInput type="time" formControlName="closing_time">
      <mat-error>Required</mat-error>
    </mat-form-field>
    <mat-form-field  class="field-message">
      <mat-label>Optional message to bidders</mat-label>
      <textarea matInput formControlName="message" rows="3" placeholder="e.g. Due to requests, we have extended the deadline..."></textarea>
    </mat-form-field>
    <div mat-dialog-actions class="dialog-actions">
      <button mat-stroked-button type="button" (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">Extend & Notify</button>
    </div>
  </form>
</div>
